export enum ORGANIZATION_PERMISSION_TYPE {
  FAMILY_PORTAL = 'FamilyPortal',
  CONTENT_MANAGEMENT = 'ContentManagement',
  COVER_PHOTO_CREATION = 'CoverPhotoCreation',
  TRIBUTE_VIDEO_CREATION = 'TributeVideoCreation',
  MUSIC_PROVIDER = 'MusicProvider',
  TEXT_ASSETS_CREATION = 'TextAssetsCreation',
  CEREMONY_SETUP = 'CeremonySetup',
  LIVE_STREAMING = 'LiveStreaming',
  DIGITAL_SIGNAGE = 'DigitalSignage',
  MEDIA_LIBRARY = 'MediaLibrary',
  OFFLINE_MUSIC_DOWNLOAD = 'OfflineMusicDownload',
  UNLIMITED_TRIBUTE_VIDEOS = 'UnlimitedTributeVideos',
  UNLIMITED_STORAGE = 'UnlimitedStorage',
  UNLIMITED_CEREMONIES = 'UnlimitedCeremonies',
  UNLIMITED_TIME = 'UnlimitedTime',
  CUSTOM_VIDEO_RESOLUTION = 'CustomVideoResolution'
}
